import { ExcelConnectActions, EExcelConnectActions } from '../actions/excel-connector-list.actions';
import { EExcelConnectorViewStatus } from 'app/connect/core/excel-connector.enum';


export const initialExcelConnectorListReducer: IExcelConnectorListReducer = {
    isLoading: false,
    connectors: [],
    viewStatus: EExcelConnectorViewStatus.EMPTY,
}

export function excelConnectorListReducer(state = initialExcelConnectorListReducer,
  action: ExcelConnectActions): IExcelConnectorListReducer {

    switch (action.type) {
        case EExcelConnectActions.GetList: {
            const newState = {
                ...state,
                isLoading: true,
            }
            return newState;
        }

        case EExcelConnectActions.GetListSuccess: {
            const connectors = action.payload.map((connector) => {
                const children = connector.children.map((child) => {
                    return { ...child };
                });
                return { ...connector, children };
            });
            const newState = {
                ...state,
                isLoading: false,
                connectors,
                viewStatus: connectors.length > 0 ? EExcelConnectorViewStatus.UNSELECT : EExcelConnectorViewStatus.EMPTY
            }
            return newState;
        }

        case EExcelConnectActions.SetViewStatus: {
            const newState = {
                ...state,
                viewStatus: action.payload
            }
            return newState;
        }

        default: {
            return state;
        }
    }
}
